import { Component, Input, OnChanges, OnInit } from '@angular/core';
import * as _ from 'lodash';
import {
    EMAIL_ADDRESS,
    PHONE_ADDRESSES,
    POST_ADDRESS,
    WEB_ADDRESSES,
    ROOM_ADDRESS
} from 'app/cs/psv/common/model/person/address-constants';
import { EAddress, PostAddress, PsvPersonProfile, RoomAddress } from 'app/cs/psv/common/model/person/psvPersonProfile';
import { RightsUtils } from 'app/cs/psv/common/service/rights-utils';

@Component( {
    selector: 'psv-person-detail-view-vcard',
    templateUrl: './person-detail-view-vcard.component.html',
    preserveWhitespaces: false
} )
export class PersonDetailViewVCardComponent implements OnInit, OnChanges {

    @Input() person: PsvPersonProfile;

    public postAddresses: (PostAddress | RoomAddress)[] = [];
    public personAttributes: any;
    public eAddresses: EAddress[];
    public toggleContact: Array<boolean> = [];
    public showOrgunitTreeLink: boolean;

    constructor(private rightUtils: RightsUtils) {
    }

    ngOnInit() {
        this.showOrgunitTreeLink = this.rightUtils.checkViewOrgunitTreeRight();
    }

    ngOnChanges(): void {
        if ( this.person.addresses ) {
            this.eAddresses = this.person.addresses.filter( address =>
                ![POST_ADDRESS, ROOM_ADDRESS].includes(address.type.hiskeyId) ) as EAddress[];
            this.postAddresses = this.person.addresses.filter( address =>
                address.type.hiskeyId === POST_ADDRESS) as PostAddress[];
            this.postAddresses = this.postAddresses.concat(this.person.addresses.filter( address =>
                address.type.hiskeyId === ROOM_ADDRESS) as RoomAddress[]);
            this.personAttributes = this.person.personAttributes;
        }
    }


    // get the Full name of person including titles and degrees according to PSV specifications
    getFullPersonNameAndTitle() {
        let fullPersonName = this.person.firstname;
        if ( this.person.nameprefix ) {
            fullPersonName = fullPersonName + ' ' + this.person.nameprefix;
        }
        fullPersonName = fullPersonName + ' ' + this.person.surname;
        if ( this.person.namesuffix ) {
            fullPersonName = fullPersonName + ' ' + this.person.namesuffix;
        }
        if ( this.person.academicdegree && this.isPrefixTitle() ) {
            let academicdegree = this.person.academicdegree.shorttext;
            if ( this.person.academicdegreesuffix ) {
                academicdegree = academicdegree + ' ' + this.person.academicdegreesuffix;
            }
            fullPersonName = academicdegree + ' ' + fullPersonName;
        }
        if ( this.person.academicdegree && !this.isPrefixTitle() ) {
            fullPersonName = fullPersonName + ' ' + this.person.academicdegree.shorttext;
            if ( this.person.academicdegreesuffix ) {
                fullPersonName = fullPersonName + ' ' + this.person.academicdegreesuffix;
            }
        }
        if ( this.person.title ) {
            return this.person.title.shorttext + ' ' + fullPersonName;
        } else {
            return fullPersonName;
        }
    }

    isEmpty( input: any ): boolean {
        return _.isNil( input ) || _.isEmpty( input );
    }

    isPrefixTitle() {
        return this.person.academicdegree.positionOfTitle === 0;
    }

    // getter ------------------------------------------------------------------------------------------
    getPersonId(): number {
        return this.person.id;
    }

    getEAddressTypeMail( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return address.type.hiskeyId === EMAIL_ADDRESS;
        } );
    }

    getEAddressTypePhone( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return PHONE_ADDRESSES.indexOf( address.type.hiskeyId ) > -1;
        } );
    }

    getEAddressTypeWeb( addresses: EAddress[] ) {
        return addresses.filter( address => {
            return WEB_ADDRESSES.indexOf( address.type.hiskeyId ) > -1;
        } );
    }

    toggleContactDataForAffiliation( toggle: boolean, id: number ) {
        this.toggleContact[id] = toggle;
    }

}
